import { StickySetting } from 'client/components/core/Sidebar/components/Settings/entities/SectionSettings/components/StickySetting'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import {
  ContentWidthEnum,
  MarginType,
  PaddingType,
} from 'common/types/styleTypes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { MarginGroup } from 'src/editor/shared/settings/groups/margin'
import { PaddingGroup } from 'src/editor/shared/settings/groups/padding'
import { ContentWidthControl } from '../../controls/content-width-control'

interface SizeAndPositionGroupProps {
  title?: React.ReactNode
  margin?: Partial<MarginType> | MarginType | undefined
  updateMargin?: (margin: Partial<MarginType>) => void
  padding?: PaddingType | undefined
  updatePadding?: (padding: PaddingType) => void
  contentWidth?: ContentWidthEnum | undefined
  updateContentWidth?: (contentWidth: ContentWidthEnum) => void
  sticky?: SectionInterface['sticky']
  htmlAttrId?: string
  updateSticky?: (value: SectionInterface['sticky']) => void
  singleDeviceMode?: boolean
  stickyOptions?: {
    title?: string
    label?: string
    tooltipText?: string
    isShowSelect?: boolean
    singleDeviceMode?: boolean
  }
}

export const SizeAndPositionGroup = (props: SizeAndPositionGroupProps) => {
  const { t } = useTranslation()

  const {
    title = 'settings_styles.size_and_position.label',
    updateMargin,
    margin,
    updatePadding,
    padding,
    updateContentWidth,
    contentWidth,
    updateSticky,
    sticky,
    htmlAttrId,
    singleDeviceMode,
  } = props

  const isMarginPropPassed = 'margin' in props && updateMargin
  const isPaddingPropPassed = 'padding' in props && updatePadding
  const isContentWidth = 'contentWidth' in props && updateContentWidth
  const isSticky = 'sticky' in props && updateSticky && htmlAttrId

  return (
    <>
      <GroupTitle>{typeof title === 'string' ? t(title) : title}</GroupTitle>
      {isContentWidth && (
        <ContentWidthControl
          contentWidth={contentWidth}
          update={updateContentWidth}
        />
      )}
      {isPaddingPropPassed && (
        <PaddingGroup
          padding={padding}
          update={updatePadding}
          singleDeviceMode={singleDeviceMode}
        />
      )}
      {isMarginPropPassed && (
        <MarginGroup
          margin={margin}
          update={updateMargin}
          singleDeviceMode={singleDeviceMode}
        />
      )}
      {isSticky && (
        <StickySetting
          entityHtmlAttrId={htmlAttrId}
          sticky={sticky}
          update={updateSticky}
          title={props.stickyOptions?.title}
          label={props.stickyOptions?.label}
          tooltipText={props.stickyOptions?.tooltipText}
          isShowSelect={props.stickyOptions?.isShowSelect}
          singleDeviceMode={props.stickyOptions?.singleDeviceMode}
        />
      )}
    </>
  )
}
